module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-middle-462871ca.svg";